import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import mcd_logo from "../../assets/img/phase3/mcd_logo.svg";
import Header from "../../components/Header/Header";
import dashboardRoutes from "../../routes/menuRoutes";
import LandingPage from "../../components/Links/LandingPage";
import Sidebar from "../../components/Sidebar/Sidebar";
import { useDispatch } from "react-redux";
import { getUserRoleInfoApi } from "../../api/userApi";
import { getRiskTypes } from "../../api/globalApi";
import { useMsal } from "@azure/msal-react";
import { Suspense } from "react";
import { useSelector } from "react-redux";
import { createAccessArray } from "../../components/AuthConfig/actionMap";
import { setAuthInfo } from "../../store/userStore";
import LoadingIndicator from "../../components/Elements/LoadingIndicator";

const DashboardLayout = (props) => {
  const { accounts } = useMsal();
  const idClaims = accounts && accounts[0]?.idTokenClaims;
  const username = accounts[0] && accounts[0].username;
  const dispatch = useDispatch();
  const authInfo = useSelector((state) => state.user.authInfo);
  const allViews = useSelector((state) => state.user.allViews);
  const allActions = useSelector((state) => state.user.allActions);

  const { location } = props;
  const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  const [pageHeader, setPageHeader] = useState("");
  const [showScatteringChart, setShowScatteringChart] = useState(false);
  const [showPreferencesModal, setShowPreferencesModal] = useState(false);

  const getRoutePath = (path) => {
    try {
      setShowScatteringChart(false);

      if (pageHeader !== path) {
        onSelectPage(path);
      }
    } catch (error) {
      console.log("error in Header getRoutePath " + error);
    }
  };

  const onSelectPage = (name) => {
    setPageHeader(name);
  };

  const onUnload = () => {
    localStorage.removeItem("detailPageState");
    localStorage.removeItem("alertState");
  };

  useEffect(() => {
    const selectedPath = location.pathname;
    if (selectedPath === "/Management") {
      setPageHeader("Risk Alerts");
    }
    if (selectedPath === "/Summary") {
      setPageHeader("Risk Summary");
    }

    window.addEventListener("beforeunload", onUnload);

    return () => window.removeEventListener("beforeunload", onUnload);
  }, []);

  useEffect(() => {
    dispatch(getRiskTypes());
  }, []);

  useEffect(() => {
    dispatch(getUserRoleInfoApi(username));
  }, [username]);

  useEffect(() => {
    if (allViews.length > 0) {
      const authMap = createAccessArray(allViews, allActions);
      dispatch(setAuthInfo(authMap));
    }
  }, [allViews, allActions]);

  const selectedPath = location.pathname;

  if (allViews.length === 0) {
    return (
      <div>
        <LoadingIndicator active={true}>
          <div className="flex-column align-items-center full-viewport first-load-wrapper">
            <div className="first-load-app-text">
              Ingredient Resiliency Control Tower
            </div>
            <img className="first-load-logo" src={mcd_logo} alt={"mcd_logo"} />
          </div>
        </LoadingIndicator>
      </div>
    );
  } else {
    return (
      <div>
        <div className="wrapper">
          <div id="main-panel" className="main-panel">
            <Sidebar
              {...props}
              pageHeader={pageHeader}
              onSelectRoute={getRoutePath}
              isSidebarExpanded={isSidebarExpanded}
              setSidebarExpanded={setSidebarExpanded}
            />
            <div className="full-width">
              <div
                className={`sticky-pos header-sticky header-panel ${
                  isSidebarExpanded ? "shrink-header-panel" : ""
                }`}
              >
                <Header
                  {...props}
                  onChangeHeader={onSelectPage}
                  pathName={pageHeader}
                  showScatteringChart={showScatteringChart}
                  setShowScatteringChart={setShowScatteringChart}
                  setShowPreferencesModal={setShowPreferencesModal}
                />
              </div>
              <div
                className={`right-panel ${
                  isSidebarExpanded ? "shrink-right-panel" : ""
                }`}
              >
                <Suspense
                  fallback={
                    <LoadingIndicator active={true}>
                      <div style={{ height: "90vh", width: "90vw" }}></div>
                    </LoadingIndicator>
                  }
                >
                  {/* <AuthorizationMap /> */}
                  {selectedPath === "/" ? (
                    <LandingPage setPageHeader={onSelectPage} />
                  ) : (
                    ""
                  )}
                  {authInfo.modules.length > 0 &&
                    dashboardRoutes
                      .filter((prop) => {
                        if (
                          prop.moduleKey &&
                          authInfo.moduleAuthKeys.indexOf(prop.moduleKey) > -1
                        ) {
                          return true;
                        } else if (!prop.moduleKey) {
                          return false;
                        } else {
                          return false;
                        }
                      })
                      .map((prop, key) => {
                        return (
                          <Route
                            path={prop.path}
                            render={(props) => (
                              <prop.component
                                {...props}
                                showPreferencesModal={showPreferencesModal}
                                setShowPreferencesModal={
                                  setShowPreferencesModal
                                }
                              />
                            )}
                            key={key}
                          />
                        );
                      })}
                </Suspense>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default DashboardLayout;
